import {inject, Injectable} from '@angular/core';
import {Observable} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {environment} from "../../../environments/environment";
import {AddQuestionCommand, AddReportCommand} from "homey-housing-lottery-app-dto";

@Injectable({
  providedIn: 'root'
})
export class QuestionService {
  private readonly http = inject(HttpClient);

  public createReport(report: AddReportCommand): Observable<void> {
    return this.http.post<void>(`${environment.apiUrl}/api/private/reports`, report);
  }

  public createQuestion(question: AddQuestionCommand): Observable<void> {
    return this.http.post<void>(`${environment.apiUrl}/api/public/questions`, question);
  }
}
